// @flow
import {endpoints} from './api';
import type {
  ConfigurationAdmin,
  Admin1Type,
  Admin2Type,
  Admin3Type,
} from './api';

const fetchLocation = async <T>(
  param: string,
  signal?: AbortSignal
): Promise<T> => {
  const response = await fetch(`${endpoints.FETCH_LOCATION}${param}`, {signal});
  return response.json();
};
const fetchAvailableLocation = async (param: string, signal: AbortSignal) => {
  const response = await fetch(
    `${endpoints.FETCH_AVAILABLE_LOCATION}${param}`,
    {signal}
  );
  return response.json();
};
const fetchValidatedLocation = async (param: string, signal?: AbortSignal) => {
  const response = await fetch(`${endpoints.FETCH_VALIDATE_LOCATION}${param}`, {
    signal,
  });
  return response.json();
};
const fetchLocationDetail = async (param: string, signal?: AbortSignal) => {
  const response = await fetch(`${endpoints.FETCH_LOCATION_DETAIL}${param}`, {
    signal,
  });
  if (!response.ok) return null;

  return response.json();
};

export const fetchAdmin1Detail = async (
  admin1Name: string,
  signal?: AbortSignal
): Promise<Admin1Type | null> => {
  return fetchLocationDetail(`?admin_1_name=${admin1Name}`, signal);
};

export const fetchAdmin2Detail = async (
  admin2Name: string,
  signal?: AbortSignal
): Promise<Admin2Type | null> => {
  return fetchLocationDetail(`?admin_2_name=${admin2Name}`, signal);
};

export const fetchAdmin3Detail = async (
  admin3Name: string,
  signal?: AbortSignal
): Promise<Admin3Type | null> => {
  return fetchLocationDetail(`?admin_3_name=${admin3Name}`, signal);
};

export const fetchCountries = (country: string, signal?: AbortSignal) =>
  fetchLocation(`/country`, signal);

export const fetchAdmin1 = (
  country: string,
  signal?: AbortSignal
): Promise<Admin1Type[]> => fetchLocation(`?country=${country}`, signal);

export const fetchAdminAvailable1 = (
  country: string,
  storeId: string,
  signal: AbortSignal
) => fetchAvailableLocation(`?country=${country}&store_id=${storeId}`, signal);

export const fetchValidatedAdmin1 = (country: string, signal?: AbortSignal) =>
  fetchValidatedLocation(`?country=${country}`, signal);

export const fetchAdmin2 = (
  country: string,
  admin1: string,
  signal?: AbortSignal
): Promise<Admin2Type[]> =>
  fetchLocation(`?country=${country}&admin_1=${admin1}`, signal);

export const fetchAdminAvailable2 = (
  country: string,
  admin1: string,
  storeId: string,
  signal: AbortSignal
) =>
  fetchAvailableLocation(
    `?country=${country}&admin_1=${admin1}&store_id=${storeId}`,
    signal
  );
export const fetchValidatedAdmin2 = (
  country: string,
  admin1: string,
  signal?: AbortSignal
) => fetchValidatedLocation(`?country=${country}&admin_1=${admin1}`, signal);

export const fetchAdmin3 = (
  country: string,
  admin1: string,
  admin2: string,
  signal?: AbortSignal
): Promise<Admin3Type[]> =>
  fetchLocation(
    `?country=${country}&admin_1=${admin1}&admin_2=${admin2}`,
    signal
  );

export const fetchAdminAvailable3 = (
  country: string,
  admin1: string,
  admin2: string,
  storeId: string,
  signal: AbortSignal
) =>
  fetchAvailableLocation(
    `?country=${country}&admin_1=${admin1}&admin_2=${admin2}&store_id=${storeId}`,
    signal
  );

export const fetchValidatedAdmin3 = (
  country: string,
  admin1: string,
  admin2: string,
  signal?: AbortSignal
) =>
  fetchValidatedLocation(
    `?country=${country}&admin_1=${admin1}&admin_2=${admin2}`,
    signal
  );

const manageAdmin = {
  PE: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Provincia',
      enabled: true,
    },
    admin3: {
      label: 'Distrito',
      enabled: true,
    },
  },
  CO: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  US: {
    admin1: {
      label: 'Estado',
      enabled: true,
    },
    admin2: {
      label: 'Ciudad',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  MX: {
    admin1: {
      label: 'Estado',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      label: 'Localidad',
      enabled: true,
    },
  },
  CL: {
    admin1: {
      label: 'Región',
      enabled: true,
    },
    admin2: {
      label: 'Comuna',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  AR: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Partido',
      enabled: true,
    },
    admin3: {
      label: 'Localidad',
      enabled: true,
    },
  },
  // BR: {
  //   admin1: {
  //     label: '',
  //     enabled: true,
  //   },
  //   admin2: {
  //     label: '',
  //     enabled: true,
  //   },
  //   admin3: {
  //     label: '',
  //     enabled: true,
  //   },
  // },
  EC: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Canton',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  BO: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  UY: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Localidad',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  PY: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Ciudad',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  ES: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Localidad',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  GT: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  CR: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Cantón',
      enabled: true,
    },
    admin3: {
      label: 'Distrito',
      enabled: false,
    },
  },
  HN: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  SV: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  NI: {
    admin1: {
      label: 'Departamento',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  DO: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      enabled: false,
    },
  },
  PA: {
    admin1: {
      label: 'Provincia',
      enabled: true,
    },
    admin2: {
      label: 'Distrito',
      enabled: true,
    },
    admin3: {
      label: 'Corregimiento',
      enabled: false,
    },
  },
  VE: {
    admin1: {
      label: 'Estado',
      enabled: true,
    },
    admin2: {
      label: 'Municipio',
      enabled: true,
    },
    admin3: {
      label: 'Parroquia',
      enabled: true,
    },
  },
};

export function getConfigurationAdmin(country: string): ConfigurationAdmin {
  return manageAdmin[country];
}
